<template>
  <div class="login">
    <div class="login-box login-form">
      <form>
        <div class="login-logo">
          <img src="../assets/img/logo.png" alt="">
        </div>
        <div class="login-item">
<!--          <input v-model="info.phone" maxlength="11" @keyup.enter="submit()" type="text" class="login-item-input" placeholder="请输入手机号" />-->
          <el-input placeholder="请输入手机号" v-model="info.phone"></el-input>
        </div>
        <div class="login-item">
<!--          <input v-model="info.password" show-password maxlength="20" @keyup.enter="submit()" type="text" placeholder="请输入密码"/>-->
          <el-input placeholder="请输入密码" v-model="info.password" show-password></el-input>
        </div>
        <div v-loading="loading">
          <el-button type="primary" @click="submit()" class="login-btn">登录</el-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      info: {
        phone: '',
        password: ''
      }
    }
  },
  methods: {
    submit () {
      let _this = this
      _this.loading = true
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(_this.info.phone)) {
        this.$message({
          message: '请输入有效的手机号码',
          center: true,
          type: 'error'
        })
        _this.loading = false
        return
      }
      if (_this.info.password === '') {
        this.$message({
          message: '请输入密码',
          center: true,
          type: 'error'
        })
        _this.loading = false
        return
      }
      const options = _this.info
      this.$axios.post('/common/login', options)
        .then((res) => {
          if (res.status === 200) {
            _this.$message({
              message: '登陆成功,即将跳转...',
              duration: 1200,
              type: 'success',
              center: true,
              onClose: function () {
                _this.loading = false
                _this.$store.commit('$_setStorage', res.data)
                _this.$router.push({path: '/user/user'})
              }
            })
          } else {
            _this.$message({
              message: res.msg,
              duration: 1200,
              type: 'error',
              center: true
            })
            _this.loading = false
          }
        })
        .catch(function (error) {
          _this.$alert(error.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              _this.loading = false
            }
          })
        })
    }
  }
}
</script>

<style scoped src="../assets/css/login.css"></style>



// WEBPACK FOOTER //
// src/components/Login.vue